import utils from '@/utils';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getPlantList: () => {
		return client
			.get(`${BASE_URL}/cc/v1/plant`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	getUseYnList: ({ plantCd, commCdType }) => {
		return client
			.post(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${commCdType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	//부서코드 2022-07-21 snjung
	getDeptCdList: () => {				
		return client
			.get(`${BASE_URL}/comm/qmsbase/deptMng/v1/deptCombo`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	// 사용자 구분 2022-07-21 snjung
	getEmployeeTypeList: ({ plantCd, commCdType }) => {
		return client
			.post(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${commCdType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	select: ({ params, currentPage, pageUnit }) => {
		const queryParams = utils.objectToQueryString({ ...params, currentPage, pageUnit });
		return client
			.get(`${BASE_URL}/user/v1/plants/${params.plantCd}/users${queryParams}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	setUsers: ({ plantCd, params }) => {
		return client
			.post(`${BASE_URL}/user/v1/status/1/plants/${plantCd}/users`, params)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	resetPassword: ({ plantCd, params }) => {
		return client
			.post(`${BASE_URL}/user/v1/status/2/plants/${plantCd}/users/passwordReset`, params)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
